import { registerPlugin } from '@capacitor/core';
const IonicCouchbaseLite = registerPlugin('CblIonicPlugin');
export { IonicCouchbaseLite };
//# sourceMappingURL=ionic-couchbase-lite.js.map